import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  OrderAdministrationDto,
  OrderAdministrationSearchRequest,
  UpsertOrderAdministrationDto
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/order-administration`;

export const searchOrderAdministration = (
    searchRequest: Partial<OrderAdministrationSearchRequest>,
    source: CancelTokenSource): Promise<Array<OrderAdministrationDto>> => {

  return axios
      .post(`${apiUri}/search`, searchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const findOrderAdministrationById = (
    orderId: number,
    source: CancelTokenSource): Promise<UpsertOrderAdministrationDto> => {

  return axios
      .get(`${apiUri}/${orderId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const saveOrder = (
    upsertDto: Partial<UpsertOrderAdministrationDto>,
    source: CancelTokenSource)
    : Promise<OrderAdministrationDto> => {

  return axios
      .post(apiUri, upsertDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editOrder = (
    orderId: number,
    upsertDto: Partial<UpsertOrderAdministrationDto>,
    source: CancelTokenSource)
    : Promise<OrderAdministrationDto> => {

  return axios
      .put(`${apiUri}/${orderId}`, upsertDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const sendOrder = (
    orderId: number,
    source: CancelTokenSource): Promise<OrderAdministrationDto> => {

  return axios
      .put(`${apiUri}/send-order/${orderId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const deliverOrder = (
    orderId: number,
    source: CancelTokenSource): Promise<OrderAdministrationDto> => {

  return axios
      .put(`${apiUri}/deliver-order/${orderId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const automaticOrder = (
    supplierId: number,
    source: CancelTokenSource): Promise<OrderAdministrationDto> => {

  return axios
      .put(`${apiUri}/automatic-order/${supplierId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteOrderById = (
    orderId: number,
    source: CancelTokenSource): Promise<number> => {

  return axios
      .delete(`${apiUri}/${orderId}`, {cancelToken: source.token})
      .then(response => response.data);
};
